var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parent-pre-loading"},[_c('div',{staticClass:"pre-loading"},[(_vm.isShowLoading)?_c('div',{staticClass:"loader edc-color-red"},[_vm._v("Loading...")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }